module.exports = __webpack_public_path__ + "static/media/fontello.9cecfa3c.ttf";